import React, { useEffect, useState } from "react"
import { Redirect } from "react-router-dom";
import styles from './payment.module.css';
import httpService from "../../../services/http.service";
import { TiArrowBack } from "react-icons/ti";
import WarningMessage from "../../common/warnMsg";
import Loader from "../../common/loader";

export const PaymentSuccessful = () => {
    const [isLoading, setIsloading] = useState(false)
    const [timer, setTimer] = useState(10)
    const [redirect, setRedirect] = useState(false); // State to control redirection

    const hashParams = new URLSearchParams(window.location.hash.split('?')[1]);
    const id = hashParams.get('session_id');
    const source = hashParams.get("source");

    const fetchSession = async () => {
        try {
            setIsloading(true)
            const data = {
                session_id: id
            }
            const response = await httpService.CreateUpdate("check-session", data)

            console.log("Response : ", response.data)

            if (response.data.ack === "0") {
                setRedirect(true) // Trigger redirection to home
            } else {
                return
            }
        } catch (error) {
            WarningMessage("Something went wrong")
        } finally {
            setIsloading(false)
        }
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setTimer(prev => {
                if (prev <= 1) {
                    clearInterval(interval);
                    setRedirect(true); // Trigger redirection when timer hits 0
                    return 0
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        fetchSession();
    }, [id]);

    if (isLoading) {
        return <Loader />
    }

    if (redirect) {
        // If redirect state is true, render the Redirect component
        if (source === "renewal") {
            return <Redirect to="/uploadfile?source=renewal" />
        } else {
            return <Redirect to="/" />
        }
    }

    return (
        <div className={styles.webcrumbs}>
            <div className={styles.container}>
                <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", gap:5}}>
                    <div className={styles.iconWrapper}>
                        <div className={styles.outerCircle}>
                            <div className={styles.innerCircle}>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                            </div>
                        </div>
                        <div className={styles.statusBadge}>
                            <div className={styles.statusDot}>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <h1 className={styles.heading}>
                        {source === "renewal" ? "Subscription Renewed!" : "Payment Successful!"}
                    </h1>

                    <p className={styles.description}>
                        {source === "renewal"
                            ? "Your subscription has been renewed successfully. RSD Credentials have been sent to your registered email address."
                            : "Your transaction has been processed successfully. RSD Credentials email has been sent to your registered email address."}
                    </p>

                    <div className="flex flex-col sm:flex-row gap-4 mb-6 md:mb-8 w-full justify-center">
                        <button onClick={() => setRedirect(true)} className={styles.redirectBtn}>
                            <TiArrowBack size={30} />
                            {`Redirect to ${source === "renewal" ? "dashboard" : "Login"} in ${timer} sec`}
                        </button>
                    </div>

                    <div className="w-full">
                        <p className={styles.footerText}>
                            Thank you for your purchase! Need help?{" "}
                            <a href="https://webcrumbs.cloud/placeholder">Contact our support team</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PaymentSuccessful
